"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _reducerInjectors = _interopRequireDefault(require("./reducerInjectors"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Dynamically injects a reducer
 *
 * @param {string} key A key of the reducer
 * @param {function} reducer A reducer that will be injected
 *
 */
var _default = _ref => {
  let {
    key,
    reducer
  } = _ref;
  return WrappedComponent => {
    class ReducerInjector extends _react.default.Component {
      constructor() {
        super(...arguments);
        _defineProperty(this, "injectors", (0, _reducerInjectors.default)(this.context.store));
      }
      componentWillMount() {
        const {
          injectReducer
        } = this.injectors;
        injectReducer(key, reducer);
      }
      render() {
        return /*#__PURE__*/_react.default.createElement(WrappedComponent, this.props);
      }
    }
    _defineProperty(ReducerInjector, "WrappedComponent", WrappedComponent);
    _defineProperty(ReducerInjector, "contextTypes", {
      store: _propTypes.default.object.isRequired
    });
    _defineProperty(ReducerInjector, "displayName", "withReducer(".concat(WrappedComponent.displayName || WrappedComponent.name || "Component", ")"));
    return (0, _hoistNonReactStatics.default)(ReducerInjector, WrappedComponent);
  };
};
exports.default = _default;